/**
 * ARKA PLAN İŞLERİ SÖZLEŞMESİ — PROJECT.md §3.2'deki tablonun kodu.
 *
 * ═══════════════════════════════════════════════════════════════════════════
 * NEDEN BURADA, NEDEN SÖZLEŞME.
 *
 * Bu liste iki uçtan da görülüyor: worker işleri ÇALIŞTIRIR, api bazılarını
 * KUYRUĞA ATAR (davet e-postası, outbox tetiği). İki tarafın iş adını ayrı
 * ayrı string olarak yazması, harf hatasının sessizce "iş hiç çalışmadı"ya
 * dönüştüğü klasik kusurdur — kuyruğa atılan iş kimsenin dinlemediği bir ada
 * gider ve hata vermez.
 *
 * İkinci ve asıl sebep: bu faz sekiz işi ALTI GÖREVE yayıyor. Aradaki
 * görevlerde bazı işler tanımlı ama uygulanmamış olacak. "Sonra yaparım"
 * notunun kaybolmaması için her işin hangi görevde uygulandığı BURADA yazılı
 * ve `apps/worker` bunu testle doğruluyor: uygulanmış işler kümesi ile
 * `gorev` alanı birbirini tutmak zorunda. Unutulan iş kırmızı verir.
 * ═══════════════════════════════════════════════════════════════════════════
 */
/**
 * Kuyruk adı, iş adının NOKTADAN ÖNCEKİ parçasıdır — türetilir, yazılmaz.
 *
 * Eşleme tablosu tutsaydık, tablo ile gerçek arasında üçüncü bir doğruluk
 * kaynağı olurdu. Türetme bunu imkânsız kılar.
 */
export function kuyrukAdi(isAdi) {
    const [kuyruk] = isAdi.split('.');
    return kuyruk ?? isAdi;
}
/**
 * PROJECT.md §3.2 tablosunun birebir karşılığı. Sıra tablodaki sırayla.
 */
export const IS_TANIMLARI = [
    {
        ad: 'alert.evaluate',
        tetik: 'zamanli',
        cron: '*/5 * * * *',
        aciklama: 'Uyarı durum makinesi — eşik, histerezis, bayat veri',
        gorev: 3,
    },
    {
        ad: 'outbox.deliver',
        tetik: 'ikisi',
        cron: '* * * * *',
        aciklama: 'Pompamatik teslimi, üstel backoff ile retry',
        gorev: 2,
    },
    {
        ad: 'rollup.hourly',
        tetik: 'zamanli',
        // Saat başından 5 dk sonra: o saatin son ölçümlerinin yazılmış olması için.
        cron: '5 * * * *',
        aciklama: 'tank_readings → tank_readings_hourly',
        gorev: 1,
    },
    {
        ad: 'rollup.backfill',
        tetik: 'ikisi',
        cron: '0 2 * * *',
        aciklama: 'Eksik saat kovalarını tamamlar',
        gorev: 1,
    },
    {
        ad: 'snapshot.monthly',
        tetik: 'zamanli',
        // Ayın 1'i değil 2'si: 1'i 08:00 hedefli ölçümün yazılmasını bekler.
        cron: '0 4 2 * *',
        aciklama: 'tank_monthly_snapshots — süresiz kayıt',
        gorev: 1,
    },
    {
        ad: 'retention.prune',
        tetik: 'zamanli',
        cron: '0 3 * * *',
        aciklama: 'Partition pisti + eski partition DROP (rollup/snapshot şartlı)',
        gorev: 1,
    },
    {
        ad: 'notification.send',
        tetik: 'ikisi',
        cron: '* * * * *',
        aciklama: 'E-posta gönderimi (ileride SMS/webhook)',
        gorev: 4,
    },
    {
        ad: 'health.digest',
        tetik: 'zamanli',
        /*
         * 05:00 UTC = 08:00 Europe/Istanbul.
         *
         * Görev 1'de bu satır '0 8 * * *' (UTC) yazıyordu ve soru açık
         * bırakılmıştı. Karar Görev 5'te verildi: insana görünen bir saat insanın
         * saatinde olmalı; UTC 08:00 Türkiye'de 11:00 demekti — sabah kahvesiyle
         * okunacak bir özet için geç.
         *
         * Cron hâlâ UTC yorumlanıyor (BullMQ'ya `tz: 'UTC'` veriyoruz); yerel
         * karşılığı burada AÇIKÇA yazılı olsun diye ofset koda gömülmedi,
         * yorumda gerekçelendirildi. Türkiye DST uygulamıyor (+03 sabit), bu
         * yüzden sabit ofset güvenli — değişirse bu satır güncellenir.
         */
        cron: '0 5 * * *',
        aciklama: 'Çevrimdışı saha özeti + entegrasyon sağlığı (yerel 08:00)',
        gorev: 5,
    },
];
/** İş adları — tip düzeyinde kullanım için. */
export const IS_ADLARI = IS_TANIMLARI.map((i) => i.ad);
/** Tekilleştirilmiş kuyruk adları (iş adlarından türetilir). */
export const KUYRUK_ADLARI = [...new Set(IS_TANIMLARI.map((i) => kuyrukAdi(i.ad)))];
/** Ada göre tanım — bulunamazsa `undefined`. */
export function isTanimi(ad) {
    return IS_TANIMLARI.find((i) => i.ad === ad);
}
//# sourceMappingURL=jobs.js.map